<template>
  <div>
    <el-form
      ref="form"
      :model="form"
      inline
      label-width="100px"
      :disabled="!editing"
    >
      <div v-for="(item, index) in form.plats" :key="item.uuid">
        <div>
          <el-tag size="large">平台{{ index + 1 }}</el-tag>
          <el-button
            style="margin-left: 20px"
            icon="el-icon-close"
            @click="handleClickRemove(index)"
            type="danger"
            v-if="editing"
          >
            删除平台
          </el-button>
        </div>
        <el-form-item label="外部平台" :prop="getFormProps(index, 'competitor')" :rules="rules.competitor" required>
          <el-select v-model="item.competitor" class="field">
            <el-option
              v-for="(label, key) in productMap"
              :value="+key"
              :key="key"
              :label="label"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="外部id">
          <el-input-number
            class="field"
            v-model="item.competitorId"
            :precision="0"
            :controls="false"
            placeholder="请输入外部id"
          ></el-input-number>
        </el-form-item>

        <el-form-item label="授权情况" :prop="getFormProps(index, 'isOnly')" :rules="rules.isOnly" required>
          <el-select
            v-model="item.isOnly"
            placeholder=""
            class="field"
          >
            <el-option v-for="(name, key) in isOnlyMap" :key="key" :label="name" :value="+key"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="录音版权比例">
          <el-input-number
            v-model="item.trackCpPercent"
            :controls="false"
            :step="0.1"
            :min="0"
            :max="100"
            class="field"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="词版权比例">
          <el-input-number
            v-model="item.wordCpPercent"
            :controls="false"
            :step="0.1"
            :min="0"
            :max="100"
            class="field"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="曲版权比例">
          <el-input-number
            v-model="item.musicCpPercent"
            :controls="false"
            :step="0.1"
            :min="0"
            :max="100"
            class="field"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="视频版权比例">
          <el-input-number
            v-model="item.mvCpPercent"
            :controls="false"
            :step="0.1"
            :min="0"
            :max="100"
            class="field"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="版权公司" :prop="getFormProps(index, 'cpCompanyId')" :rules="rules.cpCompanyId">
          <search-company
            :value.sync="item.cpCompanyId"
            placeholder="版权公司"
            class="field"
          ></search-company>
        </el-form-item>
        <el-form-item label="原始版权公司">
          <search-company
            :value.sync="item.originCpCompanyId"
            placeholder="原始版权公司"
            class="field"
          ></search-company>
        </el-form-item>
        <el-form-item label="授权起始时间" prop="copyrightFrom">
          <el-date-picker
            v-model="item.copyrightFrom"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            class="field"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="授权结束时间" prop="copyrightTo">
          <el-date-picker
            v-model="item.copyrightTo"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            class="field"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="授权文件">
          <el-upload
            action="/action/upload?type=license"
            :on-preview="handleLicensePreview"
            :on-remove="handleLicenseRemove"
            :on-error="handleError"
            :on-success="(resp) => handleLicenseSuccess(resp, item)"
            :before-upload="handleLicenseBeforeUpload"
            :file-list="item.fileList"
            :accept="'.' + licenseFileType.join(',.')"
          >
            <el-button type="primary">选择文件</el-button>
            <div slot="tip" class="el-upload__tip">只能上传 {{ licenseFileType.join('/') }} 文件</div>
          </el-upload>
        </el-form-item>
        <br>
        <el-form-item label="备注">
          <el-input
            v-model="form.remarks"
            class="textarea"
            type="textarea"
            :rows="3"
            placeholder="请输入备注,不超过 255 个字"
          ></el-input>
        </el-form-item>
      </div>
    </el-form>
    <div v-if="!form.plats.length">暂无平台</div>
    <div v-if="editing">
      <el-button icon="el-icon-plus" @click="handleClickAdd">添加平台</el-button>
    </div>
  </div>
</template>

<script>
import SearchCompany from '@/components/SearchCompany'
import { validateFileExt } from '@/utils/validate'
import { cpDefectMap, isOnlyMap, authTypeMap, productMap } from '../../const'

let uuid = 0

const licenseFileType = ['jpg', 'jpeg', 'png', 'pdf', 'msg', 'xls', 'xlsx', 'doc', 'docx', 'rar', 'zip', 'msg', 'eml']

function createPlat() {
  return {
    uuid: ++uuid,
    competitorId: '',
    isOnly: 0,
    trackCpPercent: 0.0,
    wordCpPercent: 0.0,
    musicCpPercent: 0.0,
    mvCpPercent: 0.0,
    competitor: '',
    cpCompanyId: '',
    originCpCompanyId: '',
    copyrightFrom: '',
    copyrightTo: '',
    licensePath: '',
    licenseUrl: '',
    remarks: '',
    fileList: []
  }
}

export default {
  name: 'OutPlat',

  components: {
    SearchCompany,
  },

  props: {
    disabled: {
      type: Boolean,
      default: true
    },
    list: {
      type: Array,
      required: true
    },
    editing: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      productMap,
      cpDefectMap,
      isOnlyMap,
      authTypeMap,

      form: {
        plats: [],
      },

      rules: {
        isOnly: { required: true, message: '请选择授权情况', trigger: 'change' },
        competitor: { required: true, message: '请选择竞品平台', trigger: 'change' },
        cpCompanyId: { required: true, message: '请输入版权公司', trigger: 'blur' },
      },
      licenseFileType,

    }
  },

  mounted() {
    this.init()
  },

  methods: {

    async getData() {
      await this.$refs.form.validate()
      const plats = this.form.plats.map(item => {
        let {
          cpCompanyId,
          originCpCompanyId,
          ...fields
        } = item

        cpCompanyId = cpCompanyId ? cpCompanyId.split(' -@- ')[0] : ''
        originCpCompanyId = originCpCompanyId ? originCpCompanyId.split(' -@- ')[0] : ''

        return {
          ...fields,
          cpCompanyId,
          originCpCompanyId
        }
      })

      return plats
    },
    init() {
      this.list.forEach(item => {
        const newItem = {
          ...item,
          uuid: ++uuid,
          cpCompanyId: `${item.cpCompanyId}`,
          originCpCompanyId: `${item.originCpCompanyId}`,
          copyrightFrom: item.copyrightFrom,
          copyrightTo: item.copyrightTo,
          fileList: [{
            url: item.licenseUrl,
            name: (new URL(item.licenseUrl)).pathname.split('/').pop()
          }]
        }

        this.form.plats.push(newItem)
      })
    },
    async submit() {
      try {
        await this.$refs.form.validate()
      } catch (e) {
        console.error(e)
      }
    },
    handleClickRemove(index) {
      const item = this.form.plats[index]
      if (item.id) {
        this.$message.warning('你不能删除系统中存在的平台')
        return
      }
      this.form.plats.splice(index)
    },
    handleClickAdd() {
      this.form.plats.push(createPlat())
    },
    handleUploadSuccess() {

    },
    getFormProps(index, key) {
      return `plats.${index}.${key}`
    },

    handleError(err, file, fileList) {
      this.uploading = false
      this.$message({
        type: 'error',
        message: '授权文件上传失败: ' + err.message,
        error: err
      })
    },

    handleLicenseSuccess(resp, item) {
      if (resp.code === 0) {
        this.form.licenseUrl = resp.url
        this.form.licensePath = resp.file_id

        const url = new URL(resp.data.url)
        item.fileList = [{
          url: resp.url,
          name: url.pathname.split('/').pop()
        }]
      } else {
        this.$message.error('上传授权文件异常: ' + resp.msg)
      }
      this.uploading = false
    },
    handleLicenseRemove(file, fileList) {
      this.form.licensePath = ''
      this.form.licenseUrl = ''
    },
    handleLicenseBeforeUpload(file) {
      if (!validateFileExt(licenseFileType, file.name)) {
        this.$message.warning('不支持的文件类型')
        return false
      }

      this.uploading = true
      return true
    },
    handleLicensePreview(file) {
      open(file.url, '_blank')
    },
  }
}
</script>

<style lang="scss" scoped>
.field {
  width: 210px;
}

.textarea {
  width: 500px;
}
</style>
